import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectAsyncReducer } from 'io-redux/store';
import { reducers as deliveryReducers, actionCreators as deliveryActionCreators } from '../resource/deliveryrating';
import { translate } from '../../../common/translations';
injectAsyncReducer('DELIVERY_FEEDBACK_RATING', deliveryReducers("DELIVERY_FEEDBACK_RATING", ["UPDATE"]));

class DeliveryDetailsProgress extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const props = this.props;

		return (
			<div key="deliveryProgress" className="row division white-bg">
				<div className="col-12 delivery-details-container">
					<h3 className="text-center">{translate(props.lang, 'Delivery Progress')}</h3>

					<div className="row">
						<div className="col-3" style={{ position: 'relative' }}>
							<div className="travel"></div>
						</div>
					</div>

					<div className="row align-items-center">
						<div className="col-3 text-center pr-0">
							<img src="/img/progress/hds-logo-circle.png" alt="Home Delivery Service" />
						</div>
						<div className="col-9 pl-0 align-items-center">
							{translate(props.lang, 'Home Delivery Service')}
						</div>
					</div>

					<div className="row mt-3 align-items-center">
						<div className="col-3 text-center pr-0">
							<img src="/img/progress/delivery-order-received.png" alt="Home Delivery Service" />
						</div>
						<div className="col-9 pl-0">
							{translate(props.lang, 'Delivery Order Received')}
						</div>
					</div>

					<div className="row mt-3 align-items-center">
						<div className="col-3 text-center pr-0">
							<img src="/img/progress/goods-received-for-delivery.png" alt="Home Delivery Service" />
						</div>
						<div className="col-9 pl-0">
							{translate(props.lang, 'Goods Received For Delivery')}
						</div>
					</div>

					<div className="row mt-3 align-items-center">
						<div className="col-3 text-center pr-0">
							<img src="/img/progress/goods-in-fridge-on-wheels.png" alt="Home Delivery Service" />
						</div>
						<div className="col-9 pl-0">
							{translate(props.lang, 'Goods In Fridge On Wheels')}
						</div>
					</div>

					<div className="row mt-3 align-items-center">
						<div className="col-3 text-center pr-0">
							<img src={(props.delivery.deliveryStatus === 'Completed' || props.delivery.deliveryStatus === 'Delivered' || props.delivery.deliveredDt) ? "/img/progress/goods-delivered-on.png" : "/img/progress/goods-delivered-off.png"} alt="Home Delivery Service" />
						</div>
						<div className="col-9 pl-0">
							{translate(props.lang, 'Goods Have Been Delivered')}
						</div>
					</div>

				</div>
			</div>
		);
	}
}

DeliveryDetailsProgress.contextTypes = {

};

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		searchParams: state.searchParams,
		searchValue: state.searchValue,
		item: state.DELIVERY_FEEDBACK_RATING === undefined || state.DELIVERY_FEEDBACK_RATING.item === undefined ? null : state.DELIVERY_FEEDBACK_RATING.item,
		itemAction: state.DELIVERY_FEEDBACK_RATING === undefined ? null : state.DELIVERY_FEEDBACK_RATING,
	}
};

export default connect(mapStateToProps)(DeliveryDetailsProgress);